// Based on TABS project product types

const ProductTypes = {
    KJORETIME: 1,
    PERSONALEVENT: 2,
    KURS: 3,
    ANNET: 4,
    PAKKE: 5,
    PAYMENT: 6,
    KREDITERINGER: 7,
    STANDARDPAKKE: 8,
    VARSLING: 9,
    TSP_PAYMENT: 10,
    PROXY_PAYMENT: 10,
    SCHEDULE: 11,
    TSP_INVOICE: 12,
    TSP_INVOICERECURRING: 13,
    TJENESTER: 14,
    RESOURCEEVENT: 15,
    TABS_GO: 16,
    LOSS_ON_RECEIVABLES: 17,
    TEORITENTAMEN: 18,
    ELEARNING: 18,
    TRANSFER_BALANCE_FROM_EXTERNAL_SYSTEM: 19,
    TRANSFER_BALANCE_DUE_FROM_EXTERNAL_SYSTEM: 19,
    AVAILABLE_SLOT: 20,
    ELEARNING_EXAM: 21,
    KURS_RISK_BUNDLE: 22,
    SCHEDULE_PAID: 23,
    KJORETIME_EKSTERN: 24,
    EXTERNAL_ACTIVITY: 24,
    EXTERNAL_PAYMENT: 25,
    BOOK_PYRAMID: 26,
    TRANSFER_BALANCE_CREDIT_FROM_EXTERNAL_SYSTEM: 27,
    REFUND: 28,
    DOKUMENTARKIV: 29,
    OCCUPIED_SLOT: 30,
    SHOPPING_CART: 31,
    TEMPORARY: 31,
    EXTERNAL_REFUND: 32,
    DEAD_SALE_ACTIVITY: 33,
    ELEARNING_WITH_TC: 34,
    GRUPPLEKTION: 35,

};

ProductTypes.EXCLUDE_FROM_BALANCE = [
    ProductTypes.SCHEDULE,
    ProductTypes.SCHEDULE_PAID,
    ProductTypes.KJORETIME_EKSTERN,
    ProductTypes.PERSONALEVENT,
    ProductTypes.VARSLING,
    ProductTypes.SHOPPING_CART
];

ProductTypes.TEMPORARY_SALES = [
    ProductTypes.SCHEDULE,
    ProductTypes.SCHEDULE_PAID,
    ProductTypes.SHOPPING_CART
];

ProductTypes.SALES = [
    ProductTypes.KJORETIME,
    ProductTypes.KURS,
    ProductTypes.KURS_RISK_BUNDLE,
    ProductTypes.GRUPPLEKTION,
    ProductTypes.ANNET,
    ProductTypes.DEAD_SALE_ACTIVITY,
    ProductTypes.KREDITERINGER,
    ProductTypes.TEORITENTAMEN,
    ProductTypes.ELEARNING_EXAM,
    ProductTypes.ELEARNING_WITH_TC,
    ProductTypes.BOOK_PYRAMID
];

ProductTypes.GROUP_ELEARNING = [
    ProductTypes.TEORITENTAMEN,
    ProductTypes.ELEARNING_EXAM,
    ProductTypes.ELEARNING_WITH_TC
];

ProductTypes.SALES_AND_EXTERNAL_DUE_AMOUNT = [
    ProductTypes.KJORETIME,
    ProductTypes.KURS,
    ProductTypes.KURS_RISK_BUNDLE,
    ProductTypes.GRUPPLEKTION,
    ProductTypes.ANNET,
    ProductTypes.DEAD_SALE_ACTIVITY,
    ProductTypes.KREDITERINGER,
    ProductTypes.TEORITENTAMEN,
    ProductTypes.ELEARNING_EXAM,
    ProductTypes.ELEARNING_WITH_TC,
    ProductTypes.BOOK_PYRAMID,
    ProductTypes.TRANSFER_BALANCE_FROM_EXTERNAL_SYSTEM
];

ProductTypes.TRANSFER_BALANCE_FROM_EXTERNAL_SYSTEM = [
    ProductTypes.TRANSFER_BALANCE_CREDIT_FROM_EXTERNAL_SYSTEM,
    ProductTypes.TRANSFER_BALANCE_FROM_EXTERNAL_SYSTEM
];

ProductTypes.CREDITS = [
    ProductTypes.KREDITERINGER
];

ProductTypes.LOSS_ON_RECEIVABLES = [
    ProductTypes.LOSS_ON_RECEIVABLES
];

ProductTypes.SALES_INCLUDE_PACKAGE = [
    ProductTypes.KJORETIME,
    ProductTypes.KURS,
    ProductTypes.GRUPPLEKTION,
    ProductTypes.ANNET,
    ProductTypes.DEAD_SALE_ACTIVITY,
    ProductTypes.KREDITERINGER,
    ProductTypes.TEORITENTAMEN,
    ProductTypes.ELEARNING_EXAM,
    ProductTypes.ELEARNING_WITH_TC,
    ProductTypes.BOOK_PYRAMID,
    ProductTypes.PAKKE
];

ProductTypes.ACTIVITIES = [
    ProductTypes.KJORETIME,
    ProductTypes.KURS,
    ProductTypes.GRUPPLEKTION
];

ProductTypes.TEACHER_ACTIVITIES = [
    ProductTypes.KJORETIME,
    ProductTypes.PERSONALEVENT,
    ProductTypes.KURS,
    ProductTypes.GRUPPLEKTION,
    ProductTypes.RESOURCEEVENT
];

ProductTypes.TEACHER_ACTIVITIES_WITH_VARSLING = [
    ProductTypes.KJORETIME,
    ProductTypes.PERSONALEVENT,
    ProductTypes.KURS,
    ProductTypes.GRUPPLEKTION,
    ProductTypes.RESOURCEEVENT,
    ProductTypes.VARSLING
];

ProductTypes.PAYMENTS = [
    ProductTypes.PAYMENT,
    ProductTypes.TSP_PAYMENT,
    ProductTypes.EXTERNAL_PAYMENT,
    ProductTypes.REFUND,
    ProductTypes.EXTERNAL_REFUND
];

ProductTypes.PAYMENTS_ONLY = [
    ProductTypes.PAYMENT,
    ProductTypes.TSP_PAYMENT,
    ProductTypes.EXTERNAL_PAYMENT
];

ProductTypes.PAYMENT_AND_EXTERNAL_CREDIT = [
    ProductTypes.PAYMENT,
    ProductTypes.TSP_PAYMENT,
    ProductTypes.EXTERNAL_PAYMENT,
    ProductTypes.TRANSFER_BALANCE_CREDIT_FROM_EXTERNAL_SYSTEM,
    ProductTypes.REFUND,
    ProductTypes.EXTERNAL_REFUND
];

ProductTypes.PACKAGE_CONTENT_SELLABLE_ON_PACKAGE_SALE = [
    ProductTypes.ANNET,
    ProductTypes.TJENESTER,
    ProductTypes.TEORITENTAMEN,
    ProductTypes.ELEARNING_WITH_TC,
    ProductTypes.BOOK_PYRAMID
];

export default ProductTypes;
